import { Component, OnInit } from '@angular/core';

@Component({
  selector: 'app-pumpssafe',
  templateUrl: './pumpssafe.component.html',
  styleUrls: ['./pumpssafe.component.css']
})
export class PumpssafeComponent implements OnInit {

  constructor() { }

  ngOnInit(): void {
  }

}
